import React from "react";
import { Popup } from "react-leaflet";
import CarStatusTitle from "../items/static/carStatusTitle";
import getDates from "../../shared/services/date.service";
import "./mapPopup.scss";
import markerEventIcon from "./MarkerEventIcon";

import { carsStatuses } from "../../components/sections/cars/static.carsStatuses";

const getStatusById = function (id) {
  switch (parseInt(id)) {
    case carsStatuses.inmotion.id:
      return carsStatuses.inmotion;

    case carsStatuses.parking.id:
      return carsStatuses.parking;

    case carsStatuses.fueling.id:
      return carsStatuses.fueling;

    case carsStatuses.drain.id:
      return carsStatuses.drain;

    case carsStatuses.gpsJammng.id:
      return carsStatuses.gpsJammng;

    default:
      return carsStatuses.loss;
  }
};

const MapPopup = (props) => {
  const { startTime, finishTime, status, address, info, value } = props;

  return (
    <Popup className="mapPopup" closeButton={false}>
      <div className="mapPopupContent">
        <div className="contentItem">
          <span className="data">
            <span style={{ display: "flex", alignItems: "center" }}>
              <span style={{ width: "30px" }} dangerouslySetInnerHTML={{ __html: markerEventIcon.getMarker(status) }}></span>
              <span>{getStatusById(status).title}</span>
            </span>
          </span>
        </div>

        <div className="contentItem">
          <span className="title">Время:</span>
          <span className="data">{`${getDates.getDateFormat3(startTime)}`}</span>
        </div>

        {finishTime !== undefined ? (
          <div className="contentItem">
            <span className="title">Длительность:</span>
            <span className="data">{getDates.getTimeLong(startTime, finishTime)}</span>
          </div>
        ) : null}

        {info !== undefined ? (
          <div className="contentItem">
            <span className="title">{info}</span>
            <span className="data">{value}</span>
          </div>
        ) : null}

        <div className="contentItem">
          <span className="title">Адрес:</span>
          <span className="data">{address}</span>
        </div>
      </div>
    </Popup>
  );
};

export default React.memo(MapPopup);
